module.exports = __webpack_public_path__ + "media/images/analytics_icons/analytic_kg9-fc182755d851b5fcb38ec64bea1606a9.png";